import { Stack } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer3 from "../../../components/footer/footer3";
import Header3 from "../../../components/header/header3";
import Page from "../../../components/Page"
import { categoryVariables } from "../../../components/siteBuilder/siteBuilderVariables";
import { APPLICATION_DETAILS } from "../../../config/apiSlugs";
import { defaultCategoryJson } from "../../../config/defaultValues";
import ERRORS from "../../../config/errorSlugs";
import { reduxHelper } from "../../../config/reduxHelper";
import { STRINGS } from "../../../config/strings";
import { getDynamicJson } from "../../../functions/getDynamicJson";
import { getString } from "../../../functions/getString";
import { useCategory } from "../../../hooks/useCategory";
import { dynamicComponents } from "../../../siteThemes/components";
import Page404 from "../../404";
import Cookies from 'js-cookie';
import Loading from "../../../components/Loading/loading";
import useDevice from "../../../hooks/useDevice";

const CategoryPage = ({  }) => {

    const [componentData, setComponentData] = useState(null);
    const [is404, set404] = useState(false)
    const [isLoading, setLoading] = useState(true)

    const { query } = useRouter();
    const slug = query?.slug

    const dispatch = useDispatch();

    const { reducer } = useSelector((state) => (state));
    const { layoutJson } = reducer;
    const {isMobile, isTablet} = useDevice();

    const components = componentData?.components?.map((item) => {

        const visibilityporps   = item?.properties;
        const visibleTo         = visibilityporps?.visibleTo?.value;

        const visibleToLoggedInUsers  = visibleTo && visibleTo === 'logged_in';
        const visibleToLoggedOutUsers = visibleTo && visibleTo === 'logged_out';

        const isLoggedIn              = typeof user == 'object';

        const currentDevice           = isMobile ? 'mobile' : isTablet ? 'tab' : 'pc';
        const visibleDevices          = visibilityporps?.devices;
        const visibleOnDevice         = !visibleDevices || visibleDevices.includes(currentDevice);

        const Component               = dynamicComponents[item.key]

        if(!visibleOnDevice){
            return null
        }
        if(visibleToLoggedInUsers){

            if(isLoggedIn){
                return Component
            }else{
                return null
            }

        }else if (visibleToLoggedOutUsers){

            if(authLoading){
                return null
            }if(isLoggedIn){
                return null
            }else{
                return Component
            }
            
        }else {
            return Component
        }
    })
    .filter(Boolean);

    const getCategoryData = async () => {
        const result = await useCategory(slug + '&for=question&single=true')

        if(result)
        {

            const globalLang = Cookies.get("ldfinweaklsdfj");
            const encodedGlobalLang = globalLang ? globalLang : "en"

            const categoryId = result?.id;
            const finalId    = !globalLang || encodedGlobalLang == "en" ? categoryId : `${categoryId}-${encodedGlobalLang}`;
            const jsonUrl = result?.jsonPath + 'site_builder/category/' + finalId + '.json?v=' + Math.random();
            fetch(jsonUrl)
            .then((res) => (res.json()))
            .then((response) => {

                let stringedResponse = JSON.stringify(response);
                let stringedDefaultCategoryPage = JSON.stringify(defaultCategoryJson);
                
                for(let x in categoryVariables)
                {
                    if(result[x])
                    {
                        stringedResponse = stringedResponse?.replace(categoryVariables[x], result[x])
                    }
                }

                const parsedJson = JSON.parse(stringedResponse)

                if(parsedJson?.components?.length > 0)
                {
                    const pageJson = getDynamicJson(parsedJson, layoutJson)
                    setComponentData(pageJson)
                    dispatch({
                        type: reduxHelper.UPDATE_PAGE_JSON,
                        payload: pageJson
                    })
                }
                else
                {
                    for(let x in categoryVariables)
                    {
                        if(result[x])
                        {
                            stringedDefaultCategoryPage = stringedDefaultCategoryPage?.replace(categoryVariables[x], result[x])
                        }
                    }
                    const parsedDefaultCategory = JSON.parse(stringedDefaultCategoryPage)
                    const pageJson = getDynamicJson(parsedDefaultCategory, layoutJson)
                    setComponentData(pageJson)
                    dispatch({
                        type: reduxHelper.UPDATE_PAGE_JSON,
                        payload: pageJson
                    })
                }
            })
            .catch((error) => {
                let stringedDefaultCategoryPage = JSON.stringify(defaultCategoryJson);
                for(let x in categoryVariables)
                {
                    if(result[x])
                    {
                        stringedDefaultCategoryPage = stringedDefaultCategoryPage?.replace(categoryVariables[x], result[x])
                    }
                }
                const parsedDefaultCategory = JSON.parse(stringedDefaultCategoryPage)
                const pageJson = getDynamicJson(parsedDefaultCategory, layoutJson)
                setComponentData(pageJson)
                dispatch({
                    type: reduxHelper.UPDATE_PAGE_JSON,
                    payload: pageJson
                })
            })
            .finally (()=> {
                setLoading(false)
            })
        }
        else
        {
            // set404(true)
        }
    }

    useEffect(() => {
        if(query?.slug){
            getCategoryData()
        }
    }, [slug])

     if(isLoading){
        return <Loading/>
    }

    if(is404)
    {
        return <Page404/>
    }
    
    return (
        <Page title={getString('Category') } >

            <Stack style={componentData?.pageStyle} >
            
                {
                    components?.map((item, index) => {
                        const Component = item;
                        return (
                            <Component/>
                        )
                    })
                }

            </Stack>

        </Page>
    )
};

export default CategoryPage;

// export async function getServerSideProps ({ req, res, query })
// {

//     const slug      = query?.slug;
//     const host      = req.headers.host === 'localhost:3000' ? 'accenture.e-khool.com' : req.headers.host;
//     const protocal  = req.headers['x-forwarded-proto'] || host == 'accenture.e-khool.com' ? 'https://' : 'http://';
//     const url       = protocal + host + process.env.API_SLUG + 'categories?slugs=' + slug + '&for=question&single=true';

//     const response     = await fetch(url);
//     const jsonResponse = await response.json();

//     let jsonPath = ''

//     if(!jsonResponse.error)
//     {
//         jsonPath = jsonResponse?.path + 'site_builder/category/' + jsonResponse?.categories[0]?.id + '.json?v=' + Math.random()
//     }

//     let pageJson = ''

//     try {

//         const pageJsonResult    = await fetch(jsonPath);
//         pageJson = await pageJsonResult.json()

//         if(pageJsonResult.status !== 200)
//         {                                                                        
//             pageJson = defaultCategoryJson
//         }

//         if(typeof pageJson !== 'object')
//         {
//             pageJson = defaultCategoryJson
//         }
        
//     } catch (error) {

//         pageJson = defaultCategoryJson
        
//     }

//     return {
//         props: {
//             jsonPath,
//             componentData: pageJson
//         }
//     }
// }
